import { render, staticRenderFns } from "./FormText.vue?vue&type=template&id=3478bf47&scoped=true&"
import script from "./FormText.vue?vue&type=script&lang=ts&"
export * from "./FormText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3478bf47",
  null
  
)

export default component.exports